import { apiPrime } from 'utils/bolt/apiPrime';
import Store from 'store/store';

export const checkEarlyAccess = () => {
	const withinEarlyAccess = Date.now() < __EARLY_ACCESS_END__ && Date.now() > __EARLY_ACCESS_START__;
	if (withinEarlyAccess) {
		Store.emit('EARLY_ACCESS_WINDOW');
	}
};

export const checkAccessCode = async (screeningId, accessCode, onAccessCodeSuccess) => {
	Store.emit('SHOW_FULL_LOADER', true);
	const appData = Store.get()?.appData || {};
	const copy = appData?.copy?.baseCopy || {};
	const appId = appData?.meta?.id;
	const isLocalOrDemo = __IS_DEMO__ || __IS_LOCAL__;

	try {
		const response = await apiPrime({
			method: 'get',
			path: '/check-early-access-code',
			query: {
				screening_id: screeningId,
				early_access_code: accessCode,
				app_id: appId,
				use_demo_early_access: isLocalOrDemo ? 'true' : null
			}
		});

		if (response.result !== 'ok') {
			Store.emit('SHOW_FULL_LOADER', false);
			return;
		}
		if (response.response?.invalidCode) {
			Store.emit('CHANGE_INFO_SCREEN_MESSAGE', (copy.$EARLY_ACCESS_CODE_INVALID_MESSAGE));
		} else if (response.response?.soldOut) {
			Store.emit(
				'CHANGE_INFO_SCREEN_MESSAGE',
				copy.$EARLY_ACCESS_CODE_SOLD_OUT_MESSAGE,
				copy.$EARLY_ACCESS_CODE_SUBMESSAGE
			);
			Store.emit('ADD_INFO_SCREEN_BUTTON', (copy.$ADD_WATCHLIST));
		} else {
			Store.emit('EARLY_ACCESS_CODE_ACCEPTED', (accessCode));
			Store.emit('HIDE_INFO_SCREEN');
			onAccessCodeSuccess();
		}
		Store.emit('SHOW_FULL_LOADER', false);
	} catch (e) {
		Store.emit('SHOW_FULL_LOADER', false);
		console.error('Error checking access code -', e);
		Store.emit('CHANGE_INFO_SCREEN_MESSAGE', (copy.$EARLY_ACCESS_CODE_INVALID_MESSAGE));
		return;
	}
};
